import React from 'react';
import Container from 'styled-css-framework-react/core/Container';

const ContainerComponent = () => {
    return (
        <div style={{ textAlign: "center", marginTop: "25px" }}>
        <Container>     
        <h1 style={{ color: "#e53170", paddingBottom: "25px", paddingTop: "25px" }}>Container</h1>
        <p style={{ color: "#fffffe" }}>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illo repudiandae possimus qui quas. Non quasi aspernatur consequuntur praesentium veritatis nobis dolorem quis, harum illum fuga nihil dicta voluptas magni quos.
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illo repudiandae possimus qui quas. Non quasi aspernatur consequuntur praesentium veritatis nobis dolorem quis, harum illum fuga nihil dicta voluptas magni quos.
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illo repudiandae possimus qui quas. Non quasi aspernatur consequuntur praesentium veritatis nobis dolorem quis, harum illum fuga nihil dicta voluptas magni quos.   
        </p>
        </Container>
        </div>
    )
}

export default ContainerComponent;
